export default "__VITE_ASSET__HXdcC7Ue__"